import { cx } from '@linaria/core';
import "./Sidebar.linaria.module.css!=!./Sidebar?./Sidebar.linaria.module.css?css=H4sIAAAAAAAAA2XK0Q6CIBQA0He/pB5iEGmCj30II8R0oTcuV60x/7310to6z4dZGo1VRqAUbn3kbghBuxnRT3SBANhsBfucGI3w/fLiS06EcPeHdWip15wdq1NZy59XOvWU/K+dK66+jdCINF9lhExop9QBjhqBLPmdqHnrb/tmK96ivVGCngAAAA=="
const stylesFill = "atm_a9_1r31cwp";
const stylesStrokeA = "atm_qq_1ehvy0v";
const stylesStrokeB = "atm_qq_5c9x30";
const transformStyles = "atm_tr_1sub3qo";
interface SidebarIconProps {
  opened?: boolean;
}
const Sidebar = (props: SidebarIconProps) => {
  const {
    opened
  } = props;
  return <svg xmlns="http://www.w3.org/2000/svg" data-testid="Icon__ViewSidebar" viewBox="0 0 27 16" version="1.1" height={16} width={27} className={opened ? null : transformStyles}>
            <defs id="defs1" />
            <title>{'Toggle Sidebar'}</title>
            <g id="layer1">
                <rect width="15" height="2" x="1" y="2" className={cx(stylesFill, stylesStrokeA)} />
                <rect width="15" height="2" x="1" y="7" className={cx(stylesFill, stylesStrokeB)} />
                <rect width="15" height="2" x="1" y="12" className={cx(stylesFill, stylesStrokeA)} />
                <path d="m 18.529166,1 0.08407,14 7.99447,-7.163275 z" className={cx(stylesFill, stylesStrokeA)} />
            </g>
        </svg>;
};
export default Sidebar;